import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import Sanitize      from '@utils/sanitize';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class MessageBox extends React.Component {
  render() {
    let base = this.props.base;
    
    return (
      <ul id="dm-message-list">
        { this.props.messages.map((d, key) => {
          let from_type = (d.from_type == 1) ? 'to' : 'from';
          
          if( d.is_unsupported == 1 ){
            return <li key={key} className={'system-error '+ from_type}>システムメッセージのため表示できません</li>;
          } else if( d.image_url != null ){ 
            return (
              <li key={key} className={from_type +' message-image'}>
                { (!Utils.isVideo(d.image_url))
                  ? <div className="thumbnail"><img src={d.image_url} /></div>
                  : <div className="thumbnail"><video src={d.image_url} /></div>
                }
                <p className="message-date">{Moment(d.message_date, 'YYYY-MM-DDTHH:mm:ssZZZ').format('YYYY/M/D HH:mm')}</p>
              </li>
            );
          } else if( d.message_text != undefined && d.message_text != null ){
            
            // 修正指示（エスケープ後に改行→<br />・URL→<a>の変換を行う）
            let message_text = null;
            try { message_text = Sanitize.nl2brWithLinks(d.message_text); } catch(e) {}
            
            // 新規メッセージ処理
            let already_read = [];
            try { already_read = d.already_read.split(','); } catch(e) {}
            
            let alert_html = null;
            if( d.from_type == 1 && already_read.indexOf(String(base.userData.id)) == -1 ){
              alert_html = <div className="new-icon">NEW</div>;
            }
            
            return (
              <li key={key} className={from_type +' message-text'}>
                <span dangerouslySetInnerHTML={{ __html: message_text }} />
                <p className="message-date">{Moment(d.message_date, 'YYYY-MM-DDTHH:mm:ssZZZ').format('YYYY/M/D HH:mm')}</p>
                {alert_html}
              </li>
            );
          }
          
          return null;
        })}
      </ul>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default MessageBox;